import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function ChallengesSummaryPage() {
  const { t } = useTranslation("", { keyPrefix: "training.summary" })
  const challengesBullets = t("content.challenges_bullets", { returnObjects: true }) as string[]
  const takeawaysBullets = t("content.takeaways_bullets", { returnObjects: true }) as string[]

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("content.summary_tips_header")}</h2>
        <p>{parse(t("content.intro_text"))}</p>
        <CourseList data={challengesBullets} />
        <p>{parse(t("content.solutions_intro"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("content.rag_header")}</h3>
        <p>{parse(t("content.rag_description"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("content.prompt_engineering_header")}</h3>
        <p>{parse(t("content.prompt_engineering_description"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{t("content.takeaways_header")}</h3>
        <CourseList className="list-inside list-decimal" data={takeawaysBullets} />
      </CourseSection>
    </CourseLayout>
  )
}
